import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import ChevronRight from '../../icons/ChevronRight';
import { useTranslation } from 'react-i18next';

function BlogArticle() {
    const { categoryName, slug } = useParams();
    const { t } = useTranslation();
    const [article, setArticle] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchArticle = async () => {
            setLoading(true);
            try {
                const res = await fetch(`https://api.prostay.com/WebsiteKnowledgebase/get-blog-article-by-slug/${slug}`);
                if (!res.ok) throw new Error('Failed to load article');
                const data = await res.json();
                setArticle(data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchArticle();
    }, [slug]);

    if (loading) {
        return (
            <div className="d-flex align-items-center justify-content-center mt-5">
                <div className="spinner-container">
                    <div className="custom-spinner"></div>
                </div>
            </div>
        );
    }

    if (!article) return <h2>{t('Article not found')}</h2>;

    return (
        <div className="blog-article">
            <Helmet>
                <title>{article.metaTitle || article.title}</title>
                <meta name="description" content={article.metaDescription || ''} />
                <link rel="canonical" href={`https://www.prostay.com/blog/${categoryName}/${slug}`} />
            </Helmet>

            <div className='background-image'>
                <div className='background-image-start'>
                    <div className='d-flex align-items-center gap-2 gap-md-3 breadcrumbs'>
                        <a href="/" style={{ textDecoration: 'none' }}><small>{t('Home')}</small></a>
                        <ChevronRight />
                        <a href="/blog" style={{ textDecoration: 'none' }}><small>{t('Blog')}</small></a>
                        <ChevronRight />
                        <a href={`/blog/${categoryName}`}><small>{categoryName}</small></a>
                        <ChevronRight />
                        <small style={{ color: "#1643E0" }}>{article.title}</small>
                    </div>
                    <h1 className="mt-4">{article.title}</h1>
                </div>
            </div>

            <div className="d-flex justify-content-center">
                <div className="white-content-card article-content mt-4" dangerouslySetInnerHTML={{ __html: article.content }} />
            </div>
        </div>
    );
}

export default BlogArticle;
